export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const START_MODAL_LOADING = "START_MODAL_LOADING";
export const STOP_MODAL_LOADING = "STOP_MODAL_LOADING";